module.exports = __webpack_public_path__ + "static/media/docker.5cffd8d8.jpg";